import React from 'react';
import { Input, Button, Checkbox, Icon, Card, Switch } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';
import RatesInput from './RatesInput';

const SubjectInputs = () => {
  const { control, watch } = useFormContext();

  const defaultRates = watch('defaultRates');

  return (
    <Card className="card">
      <Controller
        control={control}
        name="subjects"
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <div>
              <div className="input-label card-header">
                Subjects (To detect email)
              </div>

              {value.map((item, index) => {
                const onChangeValue = (
                  key: string,
                  type: 'input' | 'checkbox' | 'switch',
                ) => (e: any) => {
                  const newArr = [...value];
                  newArr[index] = {
                    ...newArr[index],
                    [key]:
                      type === 'switch'
                        ? !newArr[index][key]
                        : e.target[type === 'input' ? 'value' : 'checked'],
                  };
                  onChange(newArr);
                };

                return (
                  <Card className="card" key={index}>
                    <Input
                      addonAfter={
                        <Icon
                          style={{ color: 'red' }}
                          type="delete"
                          onClick={() => {
                            const newArr = [...value];
                            newArr.splice(index, 1);
                            onChange(newArr);
                          }}
                        />
                      }
                      addonBefore={
                        <Switch
                          checked={!!value[index].showOptions}
                          onChange={onChangeValue('showOptions', 'switch')}
                        />
                      }
                      className="input-text"
                      placeholder="Add subject line here"
                      value={item.name}
                      onBlur={onBlur}
                      onChange={onChangeValue('name', 'input')}
                    />

                    {value[index].showOptions && (
                      <Card style={{ marginTop: -7 }}>
                        <div>
                          <Checkbox
                            checked={!!value[index].useDefaultRates}
                            onChange={onChangeValue(
                              'useDefaultRates',
                              'checkbox',
                            )}
                          >
                            Use default rates (open, click, reply)
                          </Checkbox>
                        </div>

                        {!value[index].useDefaultRates && (
                          <RatesInput name={`subjects.${index}.rates`} />
                        )}
                      </Card>
                    )}
                  </Card>
                );
              })}

              <div className="add-button">
                <Button
                  type="primary"
                  onClick={() =>
                    onChange([
                      ...value,
                      {
                        name: '',
                        useDefaultRates: true,
                        showOptions: true,
                        rates: {
                          open: defaultRates.open,
                          click: defaultRates.click,
                          reply: defaultRates.reply,
                        },
                      },
                    ])
                  }
                >
                  Add Subject
                  <Icon type="plus" />
                </Button>
              </div>
            </div>
          );
        }}
        rules={{
          validate: (value: { name?: string }[]) => {
            return value.length > 0 && value.every(e => e.name?.length > 0);
          },
        }}
      />
    </Card>
  );
};

export default SubjectInputs;
